import React from 'react';
import styled, { css } from 'styled-components';
import { IconName } from '@24i/player-ui';
import { Pause } from './Pause';
import { Play } from './Play';
import { Forward10 } from './Forward10';
import { Replay10 } from './Replay10';
import { Cog } from './Cog';
import { Subpage } from './Subpage';
import { Back } from './Back';
import { Confirm } from './Confirm';
import { Spinner } from './Spinner';
import { EnterFullscreen } from './EnterFullscreen';
import { ExitFullscreen } from './ExitFullscreen';
import { Info } from './Info';
import { VolumeOff } from './VolumeOff';
import { Volume0 } from './Volume0';
import { Volume50 } from './Volume50';
import { Volume100 } from './Volume100';
import { AllEpisodes } from './AllEpisodes';
import { AllChannels } from './AllChannels';
import { Close } from './Close';
import { SkipPrev } from './SkipPrev';
import { SkipNext } from './SkipNext';
import { Restart } from './Restart';
import { GoToLive } from './GoToLive';
import { GeoBlock } from './GeoBlock';
const Icons = {
    [IconName.pause]: Pause,
    [IconName.play]: Play,
    [IconName.forward_10]: Forward10,
    [IconName.rewind_10]: Replay10,
    [IconName.settings]: Cog,
    [IconName.subpage]: Subpage,
    [IconName.back]: Back,
    [IconName.confirm]: Confirm,
    [IconName.spinner]: Spinner,
    [IconName.enterfullscreen]: EnterFullscreen,
    [IconName.exitfullscreen]: ExitFullscreen,
    [IconName.info]: Info,
    [IconName.volume_off]: VolumeOff,
    [IconName.volume_0]: Volume0,
    [IconName.volume_50]: Volume50,
    [IconName.volume_100]: Volume100,
    [IconName.all_episodes]: AllEpisodes,
    [IconName.all_channels]: AllChannels,
    [IconName.close]: Close,
    [IconName.skipprev]: SkipPrev,
    [IconName.skipnext]: SkipNext,
    [IconName.restart]: Restart,
    [IconName.gotolive]: GoToLive,
    [IconName.geoblock]: GeoBlock,
};
export const Icon = ({ className = '', color = 'white', backgroundColor = 'transparent', name, style = {}, }) => {
    const IconComponent = Icons[name] || (() => null);
    return (React.createElement("div", { style: Object.assign({ backgroundColor }, style), className: className },
        React.createElement("svg", { viewBox: "0 0 24 24", style: {
                display: 'block',
                margin: '0 auto',
                width: '100%',
                height: '100%',
            } },
            React.createElement("g", { strokeWidth: "1", fill: color },
                React.createElement("g", { fill: color, fillRule: "nonzero" },
                    React.createElement(IconComponent, null))))));
};
const baseIconStyles = css `
    position: relative;
    width: 24px;
    height: 24px;
`;
export const StyledIcon = styled(Icon) `
    ${baseIconStyles}
`;
export { IconName };
//# sourceMappingURL=index.js.map